import { Box, Typography } from "@mui/material";
import customConfig from "../../../config";
import Button from "../Button/Button";
// import { useHistory } from "react-router-dom";

const ErrorFallback = ({ resetErrorBoundary }) => {
//   const history = useHistory();

  const handleGoHome = () => {
    console.log("handleGoHome---")
    // history.push("/");
    window.location.href = "/";
  };

//   const handleReload = () => {
//      console.log("handleGoHome2---")
//     window.location.reload();
//   };

  return (
    <Box
      role="alert"
      sx={{
        p: 4,
        textAlign: "center",
        marginTop: "50px",
      }}
    >
      <Typography variant="h5" gutterBottom>
        {customConfig?.SOMETHING_WENT_WRONG}
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        We encountered an unexpected issue. If the problem continues, contact
        support.
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          justifyContent: "center",
          marginTop: "30px",
        }}
      >
        {/* <Button
          variant="primary"
          size="medium"
          onClick={resetErrorBoundary}
        >
          Retry
        </Button> */}

        <Button variant="primary" size="medium" onClick={handleGoHome}>
          Go to Dashboard
        </Button>

        {/* <Button variant="primary" size="medium" onClick={handleReload}>
          Reload Page
        </Button> */}
      </Box>
    </Box>
  );
};

export default ErrorFallback;
